import Social from "components/common/Social";
import { motion } from "framer-motion";
import Image from "next/image";
import { teamMemberType } from "types/allTypes";
import { teamAnim } from "utils/animation";
import { framerProps } from "utils/util";

interface props {
  data: teamMemberType;
  index: number;
}
const MemberCard: React.FC<props> = ({ data, index }) => {
  return (
    <motion.li
      layout
      {...framerProps}
      custom={index % 9}
      variants={teamAnim}
      className="group w-[283px] card-surface overflow-hidden transition-[border-color,background-color,box-shadow] duration-300
      hover:border-primary-50/40 hover:bg-white/[0.05] hover:shadow-[0_0_40px_rgba(126,92,255,0.12)]"
    >
      <div className="w-full h-full pt-8 pb-7 flex flex-col justify-start items-center font-heading">
        <span className="w-[160px] h-[160px] relative rounded-full overflow-hidden ring-2 ring-white/10 group-hover:ring-primary-50/60 duration-300">
          <Image
            src={data.image}
            quality={90}
            width={160}
            height={160}
            alt={data.name + " " + data.role + " spila"}
            placeholder="blur"
            className="group-hover:scale-105 duration-500 ease-in-out object-cover"
            sizes="12rem"
          />
        </span>
        <div className="px-5 text-center">
          <h4 className="text-xl font-bold mt-5 text-white">{data.name}</h4>
          <p className="text-sm font-normal font-body mt-1.5 text-zinc-400 leading-snug">
            {data.role}
          </p>
          <span
            className="inline-block mt-3 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] font-medium text-zinc-400"
          >
            {data.roleType.name}
          </span>
        </div>
        <ul className="flex justify-center items-center gap-2 mt-6">
          {data.social.map((social, index) => {
            return (
              <Social
                key={data.name + data.id + index}
                data={social}
                hasTransition={true}
                width={"36px"}
                svgWidth={"18px"}
              />
            );
          })}
        </ul>
      </div>
    </motion.li>
  );
};

export default MemberCard;
